import { SVGProps, Ref, forwardRef } from 'react';

export const PriceTagFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M11 4.066c.537 0 .695.163.747.226.09.107.186.333.186.708s-.097.6-.186.708c-.052.063-.21.225-.747.225-.538 0-.696-.163-.748-.225-.09-.107-.186-.333-.186-.708s.097-.6.186-.708c.052-.062.21-.226.748-.226"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m16 8-5.335 5.335-.628.625a41 41 0 0 1-.424.413l-.197.187q-.104.098-.204.19a15 15 0 0 1-.345.305c-.737.63-1.316.947-1.973.947-1.105 0-1.994-.89-3.772-2.667l-.457-.457C.943 11.156.055 10.268.001 9.21l-.003-.104c0-.966.681-1.767 2.042-3.143l.625-.628L8 0h8zm-5-5.334c-1.64 0-2.257 1.026-2.327 2.115L8.666 5c0 1.166.584 2.333 2.334 2.333S13.333 6.166 13.333 5c0-1.094-.513-2.188-2.018-2.32z"
                fill="currentColor"
            />
            <path
                d="M14.898 11.611c-.737 2.42-1.106 3.63-2.086 4.148-.665.35-1.432.288-2.608-.02q.396-.368.817-.784l.003-.003.628-.625.003-.002 3.475-3.475z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PriceTagFilledSize16Glyph.displayName = 'PriceTagFilledSize16Glyph';
